import React from "react";
import "./rangenumber.scss";

const RangeNumberInput = ({
  value,
  onChange,
  className,
  step = 1,
  min = 0,
  max = 100,
  unit = "px",
  label = "",
  resetValue = 0,
  showArrows = false,
}) => {
  value = Number(value);

  if (isNaN(value)) {
    value = resetValue;
  }
  if (value === undefined || value === null) {
    value = "";
  }
  const handleRangeValueChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <>
      {label && <div className="text-grigora-base">{label}</div>}
      <div className="flex flex-1 justify-between gap-5 mt-0">
        <div className="flex-1 flex items-center gap-[10px]">
          <input
            min={min}
            max={max}
            onChange={handleRangeValueChange}
            value={value}
            step={step}
            type="range"
            className="flat-slider
            flex-1
            accent-ui-dark-blue
            border-0
            bg-ui-range
            appearance-none
            h-2 rounded-full
            outline-none"
          />
          <input
            type={`${showArrows ? "number" : "text"}`}
            className="p-2 rounded-full
              w-[100px]
              outline-none"
            value={value}
            onChange={handleRangeValueChange}
            min={min}
            max={max}
          />
        </div>
      </div>
    </>
  );
};

export default RangeNumberInput;
